let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gnj39")).then(() => parcelRequire('g8rvF'));